<template>
    <vx-card title="Редактировать категорию тегов" id="loader">
        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input
                        v-model="form.name"
                        :danger="!!errors.name"
                        :danger-text="errors.name"
                        autocomplete="off"
                        label="Название категории"
                        class="mt-1 w-full required"
                    />
                </div>
                  <div class="mt-1">
                    <vs-checkbox  readonly v-model="form.required" class="w-full">В группе обязательно выбрать хотя бы один тег</vs-checkbox>
                </div>
            </div>
        </div>
        <vs-button class="mt-5 mr-2" color="success" @click="saveAdTagCategory()" type="filled"> Сохранить </vs-button>
        <vs-button class="mt-5" color="primary" @click="cancelEdit()" type="filled"> Отмена </vs-button>
    </vx-card>
</template>


<script>
import vSelect from 'vue-select';
import axios from 'axios';

export default {
    name: 'adTagCategory-edit',
    props: ['id'],
    data() {
        return {
            adTag: undefined,
            form: {
                name: undefined,
                adTagCategoryId: undefined,
                required: false
            },
            errors: {
                name: '',
                adTagCategoryId: ''
            }
        };
    },
    components: {
        'v-select': vSelect
    },
    methods: {
        loadData() {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            this.axios
                .all([this.axios.get('adTagCategories/'+ this.id)])
                .then(
                    axios.spread((adTagCategory) => {
                        this.$vs.loading.close('#loader > .con-vs-loading');
                        this.adTagCategory = adTagCategory.data;
                        this.form.name = adTagCategory.data.name;
                        this.form.required = adTagCategory.data.required;
                    })
                )
                .catch((err) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    this.$vs.notify({
                        title: 'Ошибка!',
                        text: 'Ошибка загрузки категории тегов.',
                        color: 'danger'
                    });
                })
                .finally(() => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                });
        },
        saveAdTagCategory() {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            const params = Object.assign({}, this.form, { id: this.id });
            this.$axios({
                method: 'PUT',
                url: 'adTagCategories/' + this.id,
                params: params,
                errors: this.errors,
                success: (user) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    this.$vs.notify({
                        title: 'Успешно обновлено',
                        text: 'Категория тегов успешно обновлена',
                        color: 'success'
                    });
                    this.$router.push('/content-quality/ad-tag-category');
                },
                catch: (err) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    return this.$vs.notify({
                        title: 'Ошибка!',
                        text: err.response.data,
                        color: 'danger'
                    });
                }
            });
        },
        cancelEdit() {
            this.$router.push('/content-quality/ad-tag-category');
        }
    },
    mounted() {
        this.loadData();
    }
};
</script>

<style>
.select-error > div {
    border: 1px solid rgba(var(--vs-danger), 1) !important;
}
</style>